import { createFileRoute } from "@tanstack/react-router";
import { providerPageApiRoute } from "@/features/providers/index";

export const Route = createFileRoute("/api/v1/providers/$providerId/page")({
    ...providerPageApiRoute,
});
